import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConnectionService } from 'src/app/connection.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.css']
})
export class TagComponent implements OnInit {
  abiJson: any;
  isSearch: boolean;
  tranStatus: any;
  transactionInfo: any;
  type: any
  search: any;
  blockId: any;
  blockDetailsList: any;
  Obj: any = {}
  blockTransactionInfo: any;
  transTime: any;
  timeString: string = '';


  constructor(private conn: ConnectionService, private activatedRoute: ActivatedRoute, private spinner: NgxSpinnerService, private alert: ToastrService) {
    this.type = this.activatedRoute.snapshot.params['type']
    this.search = this.activatedRoute.snapshot.params['search']
    this.conn.setBlock.subscribe((res: any) => {
      this.type = this.activatedRoute.snapshot.params['type']
      this.search = this.activatedRoute.snapshot.params['search']
      if (res == true) {
      this.searchDetails()
      }
    })
    // setTimeout(() => {
      this.searchDetails()
    // }, 1000)
   
  }

  ngOnInit() {
    this.Obj.value = this.type
    this.Obj.search = this.search.length

    setTimeout(() => {
      this.calculateTimeRemaining()
    }, 4000)
  }

  searchDetails() {
    // this.spinner.show()
    this.conn.postUrl('users/search', { type: this.type, searchTerm: this.search }).subscribe((res: any) => {
      if (res.success == true) {
        // this.spinner.hide()
        this.tranStatus = res.success
        // this.blockId = res.data[0]?.blockID ? res.data[0].blockID : '' || res.data.blockData ? res.data.blockData.blockID : ''
        if (this.type == 'allFilters' && this.Obj.search <= 7) {
          if(res.data[0]?.blockData || res.data[0]){
            console.log("sdfgdfg")
            this.blockDetailsList = res.data[0].blockData ? res.data[0].blockData.block_header.raw_data : res.data[0].block_header.raw_data
            this.transactionInfo = res.data[0].transblock ? res.data.transblock[0] : ''
            this.transTime = this.blockDetailsList.timestamp
            this.blockId = res.data[0].blockID ? res.data[0].blockID : '' || res.data.blockData ? res.data.blockData.blockID : ''
          }
          else {
            console.log("sdfgdfffffffffffg")
            this.blockDetailsList = res.data.blockData ? res.data.blockData[0].block_header.raw_data : res.data[0].block_header.raw_data
            this.transactionInfo = res.data.transblock ? res.data.transblock[0] : ''
            this.transTime = this.blockDetailsList.timestamp
            this.blockId = res.data.blockData[0].blockID ? res.data.blockData[0].blockID : '' || res.data.blockData ? res.data.blockData.blockID : ''
          }
         
        }
        else if (this.type == 'blockNumber') {
          if(res.data[0]?.blockData || res.data[0]){
            console.log("dgdfg")

          this.blockDetailsList = res.data[0].blockData ? res.data[0].blockData.block_header.raw_data : res.data[0].block_header.raw_data
          this.transactionInfo = res.data[0].transblock ? res.data.transblock[0] : ''
          this.transTime = this.blockDetailsList.timestamp
          this.blockId = res.data[0].blockID ? res.data[0].blockID : '' || res.data.blockData ? res.data.blockData.blockID : ''
          }
          else {
            console.log("eeee")

            this.blockDetailsList = res.data.blockData ? res.data.blockData[0].block_header.raw_data : res.data[0].block_header.raw_data
            this.transactionInfo = res.data.transblock ? res.data.transblock[0] : ''
            this.transTime = this.blockDetailsList.timestamp
            this.blockId = res.data.blockData[0].blockID ? res.data.blockData[0].blockID : '' || res.data.blockData ? res.data.blockData.blockID : ''
          }
        }
        else {
          this.transactionInfo = res.data[0] ? res.data[0] : res.data
          this.blockDetailsList = res.data.block_header ? res.data.block_header.raw_data : ''
          this.transTime = this.blockDetailsList.timestamp
        }
      }
    })
  }

  calculateTimeRemaining() {
    const currentTime = new Date().getTime();

    const timeDifference = currentTime - this.transTime;
    if (timeDifference > 0) {
      const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
      this.timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      setTimeout(() => {
        this.calculateTimeRemaining();
      }, 1000);
    } else {
      // this.timeString = 'Timer expired!';
    }
  }
  copyText(val: string) {
    let selBox = document.createElement('input');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.alert.success('Copied to the clipboard');
  }

}
